require('./js/mode')
require('./js/center')
